
import { DraftDoc } from './types'

export const filterDocs = (docs: Array<DraftDoc|null>) => {
  const present = docs.filter((doc: DraftDoc|null): doc is DraftDoc => doc !== null)
  return present
}
